import Radio from "backbone.radio";
import { Component } from "react";

import { store } from "common/store";

import { EMAIL_ADMINS_FOR_PERMISSIONS } from "common/actions/users";

import "./noAccountPermissions.scss";

export class NoPermissions extends Component {
    static Logout() {
        Radio.channel("security").request("user:logout", { rememberLastUrl: false });
        return false;
    }
    
    constructor(props) {
        super(props);
        this.state = {
            requestedAccess: false
        };
    }
    
    sendEmail = () => {
        EMAIL_ADMINS_FOR_PERMISSIONS(store.getState().common.user._id).then((b) => {
            if (b) {
                this.setState({ requestedAccess: true });
            }
        });
    }
    
    render() {
        const getButtonTitle = () => (!this.state.requestedAccess ? <span>Request access</span> : <span><i className="far fa-check request-access" />Access request sent</span>);
        
        const getInternalSupportContact = () => {
            const authInfo = Radio.channel("security").request("user:get:authInfo");
            let worldPay;
            try {
                worldPay = JSON.parse(authInfo).sso;
            } catch (err) {
                worldPay = false;
            }
            
            if (worldPay) {
                return (
                    <div className="no-admins">
                        Admins assign permissions, but your organization does not have an admin. <br/>
                        Contact your Worldpay representative to add an admin via the Service Portal.
                    </div>
                );
            }
            return (
                <div className="no-admins">
                    Admins assign permissions, but your organization does not have an admin.  Contact Pazien to assign an admin and enable access.
                    <div className="btn-container">
                        <button type="button" className="btn-request" onClick={this.sendEmail}>{getButtonTitle()}</button>
                    </div>
                </div>
            );
        };
    
        const renderAdmin = (admin) => (<li key={admin.email}><div className="admin"><div>{admin.name}</div> <div>{admin.email}</div></div></li>);
        
        const renderContactInfo = (admins) => {
            if (admins.length) {
                return (
                    <>
                        <div className="no-permissions-msg">
                            The following admins can enable access.
                        </div>
                        <div className="admin-list">
                            <ul>
                                {this.props.admins.map((admin, index) => renderAdmin(admin, index))}
                            </ul>
                        </div>
                        <div className="btn-container">
                            <button type="button" className="btn-request" onClick={this.sendEmail}>{getButtonTitle()}</button>
                        </div>
                    </>
                );
            }
            return getInternalSupportContact();
        };
        
        return (
            <div className="no-permissions">
                <div className="no-permissions-header">
                    Your account does not have user permissions assigned.
                </div>
                {renderContactInfo(this.props.admins)}
                <div className="logout-wrap">
                    <a href="#" className="logout" onClick={NoPermissions.Logout}>Return to sign in</a>
                </div>
            </div>
        );
    }
}
